'use client'

import React, { createContext, useContext, useMemo, useState } from 'react'

type ChannelContextType = {
  selectedChannel: string
  selectedChannelName: string
  setSelectedChannel: (value: string, name?: string) => void
}

type ChannelItem = {
  id: string
  name: string
  emoji: string
  canPost: boolean
  permission?: "public" | "private" | "closed"
  description?: string
  locked?: boolean
  accessType?: "open" | "product" | "level" | "badge" | string
  accessReason?: "login" | "product" | "level" | "badge" | "member" | null
  productId?: number | null
  levelId?: number | null
  badgeId?: number | null
  visibilityMode?: "locked" | "hidden" | string | null
}

const ChannelContext = createContext<ChannelContextType | undefined>(undefined)

export function ChannelProvider({ children }: { children: React.ReactNode }) {
  const [selectedChannel, setSelectedChannelState] = useState<string>('general')
  const [selectedChannelName, setSelectedChannelName] = useState<string>('Todos')

  function setSelectedChannel(value: string, name?: string) {
    setSelectedChannelState(value)
    setSelectedChannelName(name || (value === 'general' ? 'Todos' : 'Canal'))
  }

  const value = useMemo(
    () => ({
      selectedChannel,
      selectedChannelName,
      setSelectedChannel,
    }),
    [selectedChannel, selectedChannelName]
  )

  return (
    <ChannelContext.Provider value={value}>
      {children}
    </ChannelContext.Provider>
  )
}

export function useChannel() {
  const ctx = useContext(ChannelContext)
  if (!ctx) {
    throw new Error('useChannel must be used within ChannelProvider')
  }
  return ctx
}